import { shellStringResources } from '../../Resources/ShellStringResources';
import { IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { CopySource } from './copysource';

export type CopySourceMode = 'table' | 'query' | 'storedProcedure' | 'report';

@Metamodel.model({
    abstract: true
})
export class TabularCopySource extends CopySource {
    public static readonly READER_QUERY: IAttribute;
    @Metamodel.attribute({
        templatable: true,
        association: 'READER_QUERY',
        bypassExpressionValidation: (source: TabularCopySource) => {
            return source.mode !== 'query';
        },
        display: shellStringResources.QueryLabel
    })
    public readerQuery?: string;

    // UI model only
    public mode: CopySourceMode = 'table';
}
